module.exports = __webpack_public_path__ + "media/images/element/song-98c1b719e5b73adcbb64949c261e7629.svg";